import { RecordFile } from '../../../types';
import React from 'react';
import PurchaseOrderInfoView from './PurchaseOrderInfoView';
import PurchaseOrderInfoTable from './PurchaseOrderInfoTable';
import AttachmentUpload from '../../../components/AttachmentUpload';
import { PurchaseOrderInfo } from '../../../types/PurchaseOrder';

interface PurchaseOrderInfoContentProps {
  data: PurchaseOrderInfo;
  attachments?: RecordFile[];
  /** Set together to allow adding/removing; omit any and the list stays read-only. */
  api?: string;
  recordId?: string;
  canEdit?: boolean;
}
const PurchaseOrderInfoContent: React.FC<PurchaseOrderInfoContentProps> = ({
  data,
  attachments,
  api,
  recordId,
  canEdit,
}) => {
  return (
    <div className={'w-9/12 space-y-4 h-[calc(84vh)] overflow-auto m'}>
      <div className={'p-4 rounded'}>
        <PurchaseOrderInfoView purchaseOrderInfo={data} />
        <AttachmentUpload
          attachments={attachments}
          api={api}
          recordId={recordId}
          canEdit={canEdit}
        />
        <div className={'py-4'}>
          <span className={'text-base font-semibold leading-6'}>
            Order Lines
          </span>
        </div>
        <PurchaseOrderInfoTable orderLines={data.orderLines} />
      </div>
    </div>
  );
};
export default PurchaseOrderInfoContent;
